<template>
<div class="meeting-area area">
    <div class="meeting color-E">
          <table height="100%" width="100%" border="0" cellpadding="0" cellspacing="0">
            <tr>
                <td height="1%" width="100%" align="center">
                    <div id="div-header-container" class="color-A">
                        <div id="div-header">
                            <div id="div-logo">

                                <div id="span-property-name-tablet" class="font-A tablet page_header_text">
                                    
                                </div>
                            </div>
                            <div id="div-address">
                                <div id="span-property-location" class="font-A page_header_text">
                                    
                                </div>
                                <div id="span-property-name" class="font-B page_header_text">
                                   
                                </div>
                            </div>
                        </div>
                    </div>
                </td>
            </tr>
            <tr>
                <td id="td-main-container" height="98%" width="100%" valign="middle" align="center">
                    <div style="height:15px;"></div>

                    <div class="div-standard-container color-D">
                      <input type="hidden" id="iMethodId" name="iMethodId" value="3" />

                      <div class="font-E color-A page_header_text" style="line-height:40px;">
                        connect with a meeting access code
                      </div>
                      <div style="height:10px;"></div>
                      <div class="error-message">
                          <div class="headline">Please correct the following and try again.</div>
                          <br />
                          <div class="error-body"></div>
                      </div>

                      <div style="height:10px;"></div>
                      <div class="info-message">
                        <div class="info-body font-E info_body_text motd-area" style="background-color:transparent;" v-if="motd">
                          {{ motd }}
                        </div>
                        <div class="info-body font-E info_body_text motd-area" style="background-color:transparent;" v-if="!motd">
                          There is no message of the day defined yet.
                        </div>
                      </div>

                      <div style="height:10px;"></div>
                      <div class="info-message">
                          <div class="info-headline font-B-container info_header_text"></div>
                          <br />
                          <div class="info-body font-E info_body_text" style="background-color:transparent;"></div>
                      </div>

                      <div style="padding-top:20px;">
                        <span class="font-C-container info_header_text">Please enter your access code below.</span>
                      </div>

                      <div style="padding-top:10px;" class="font-B-container info_header_text">
                        access code
                        <br />
                        <input class="input-field" style="width:135px;" type="text" v-model="sCode" size="20" />
                      </div>

                      <div style="padding-top:20px; padding-left:25px; padding-right:25px;">
                        <button class="button-0 font-E color-A page_header_text" @click="connectAccessCode">connect</button>
                      </div>

                      <div style="padding-top:20px; padding-bottom:20px;">
                          <span class="font-G-container">
                              &nbsp;&nbsp;|&nbsp;&nbsp;
                              Connect with <a href="">name / room number</a>
                          </span>
                      </div>

                    </div>
                </td>
            </tr>
          </table>
    </div>
</div>
</template>

<script>

import {
  ADD_USER
} from "@/store/actions.type";

import mappings from "@/mappings/index";

import { mapGetters } from "vuex";

import { required, minLength, between } from 'vuelidate/lib/validators'

export default {
  name: "Meeting",
  computed: {
    ...mapGetters(["session", "motd"])
  },
  data() {
    return {
      sCode: null
    }
  },
  methods: {
    connectAccessCode() {
      this.$store.dispatch(ADD_USER, {
        sCode: this.sCode,
        session: this.session
      })
      .then((res) => {
        
      });
    }
  }
}

</script>

<style scoped>

</style>